import React from 'react';

import Chip from '@mui/material/Chip';

type Props = {
  label: string;
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success' | 'default';
  variant?: 'filled' | 'outlined';
  size?: 'small' | 'medium';
};

/**
 * ガイド画面で表示用のモックChip
 */
const GuideMockChip: React.FC<Props> = ({
  label,
  color = 'default',
  variant = 'filled',
  size = 'small',
}) => {
  return <Chip label={label} color={color} variant={variant} size={size} />;
};

export default GuideMockChip;
